var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpHeaderType, handleResponse, HttpContentType, EnvironmentService } from "../../common";
import { PhotoCaptureServiceHeader } from '../constants';
export class PhotoCaptureIntelligentImageDetailOCRService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static generateRequestHeaders() {
        return {
            [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
            [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
            [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
            [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName
        };
    }
    static getRequest(uri, method, body) {
        return new Request(uri, {
            method: method,
            cache: HttpCacheType.NO_CACHE,
            headers: PhotoCaptureIntelligentImageDetailOCRService.generateRequestHeaders(),
            body: JSON.stringify(body)
        });
    }
    photoCaptureImageDetailOCR(requestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = PhotoCaptureIntelligentImageDetailOCRService.getRequest(EnvironmentService.getEnvironment().ocrApiUrl, HttpMethodType.POST, requestPayload);
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureImageDetailOCRService.js.map